export const managementCertificationsDiscList = [
  `At Vis Group, we pride ourselves on maintaining rigorous
   standards of quality and security, exemplified by our ISO
   certifications. Our commitment to excellence is underscored
   by certifications such as ISO 9001 and ISO 27001, which reflect
   our dedication to quality management and information security management
   systems. These certifications validate our adherence to international
   standards and best practices, ensuring that our clients receive services
    that meet the highest industry benchmarks.`,
  `ISO 9001 certification demonstrates our robust quality management
   system, ensuring consistent delivery of products and services that
    meet customer and regulatory requirements. It reflects our commitment
    to continuous improvement, customer satisfaction, and operational efficiency.
     Similarly, ISO 27001 certification highlights our stringent information security
      practices, safeguarding sensitive data and ensuring confidentiality, integrity,
       and availability of information assets.`,
  `By choosing Vis Group, you partner with a company that prioritizes 
  quality, security, and customer satisfaction. Our ISO certifications
   are a testament to our unwavering commitment to operational excellence
    and continuous enhancement of our processes to meet evolving industry needs.`,
];

// export const project = [
//   {
//     label: "Denmark",
//     projects: [
//       {
//         project: "Drive Test",
//         year: "2024",
//         duration: "1 Month 11 Days",
//         projectArea: "Benchmark",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2011",
//         duration: "3 years",
//         projectArea: "Project Area Two Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2015",
//         duration: "3 Month 7 Days",
//         projectArea: "Project Area Three Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2020",
//         duration: "1 + year",
//         projectArea: "Project Area Four Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2020",
//         duration: "1 + year",
//         projectArea: "Project Area Four Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2017",
//         duration: "2+ years",
//         projectArea: "Project Area Five Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2017",
//         duration: "2+ years",
//         projectArea: "Project Area Five Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2021",
//         duration: "15 days",
//         projectArea: "Project Area Six Name",
//       },
//     ],
//   },
//   {
//     label: "United Kingdom",
//     projects: [
//       {
//         project: "Name here Independent auditor Benchmark",
//         year: "2023",
//         duration: "1 Month 11 Days",
//         projectArea: "Project Area One Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2011",
//         duration: "3 years",
//         projectArea: "Project Area Two Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2015",
//         duration: "3 Month 7 Days",
//         projectArea: "Project Area Three Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2020",
//         duration: "1 + year",
//         projectArea: "Project Area Four Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2017",
//         duration: "2+ years",
//         projectArea: "Project Area Five Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2021",
//         duration: "15 days",
//         projectArea: "Project Area Six Name",
//       },
//     ],
//   },
//   {
//     label: "Korea",
//     projects: [
//       {
//         project: "Name here Independent auditor Benchmark",
//         year: "2023",
//         duration: "1 Month 11 Days",
//         projectArea: "Project Area One Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2011",
//         duration: "3 years",
//         projectArea: "Project Area Two Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2015",
//         duration: "3 Month 7 Days",
//         projectArea: "Project Area Three Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2020",
//         duration: "1 + year",
//         projectArea: "Project Area Four Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2017",
//         duration: "2+ years",
//         projectArea: "Project Area Five Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2021",
//         duration: "15 days",
//         projectArea: "Project Area Six Name",
//       },
//     ],
//   },
//   {
//     label: "Pakistan",
//     projects: [
//       {
//         project: "Name here Independent auditor Benchmark",
//         year: "2023",
//         duration: "1 Month 11 Days",
//         projectArea: "Project Area One Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2011",
//         duration: "3 years",
//         projectArea: "Project Area Two Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2015",
//         duration: "3 Month 7 Days",
//         projectArea: "Project Area Three Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2020",
//         duration: "1 + year",
//         projectArea: "Project Area Four Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2017",
//         duration: "2+ years",
//         projectArea: "Project Area Five Name",
//       },
//       {
//         project: "Independent auditor Benchmark",
//         year: "2021",
//         duration: "15 days",
//         projectArea: "Project Area Six Name",
//       },
//     ],
//   },
// ];

export const projects = [
  // projects data section for Europe and Germany
  {
    label: "Europe",
    countries: [
      //Germany
      {
        name: "Germany",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "05 Days",
            projectArea: "Device Testing",
          },

          {
            project: "Drive Test",
            year: "2024",
            duration: "06 Days",
            projectArea: "International Roaming",
          },

          {
            project: "Drive Test",
            year: "2024",
            duration: "03 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Optical Fiber Blowing, Splicing",
            year: "2023-2024",
            duration: "150 Days",
            projectArea: "OFC Deployment",
          },

          {
            project: "Drive Test",
            year: "2024",
            duration: "03 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test and Walk Test",
            year: "2023",
            duration: "75 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Device Testing",
            year: "2023",
            duration: "15 Days",
            projectArea: "User Acceptance Testing",
          },

          {
            project: "Device Testing",
            year: "2023",
            duration: "35 Days",
            projectArea: "User Acceptance Testing",
          },

          {
            project: "Device Testing",
            year: "2023",
            duration: "02 Days",
            projectArea: "User Acceptance Testing",
          },

          {
            project: "Railway Test",
            year: "2023",
            duration: "05 Days",
            projectArea: "Network Performance Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "04 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "40 Days",
            projectArea: "Network Implementation",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "15 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Walk Test (RailWay)",
            year: "2022",
            duration: "15 Days",
            projectArea: "Network Performance Testing ",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "12 Days",
            projectArea: "Network pre-benchmark Testing ",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network pre-benchmark Testing ",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "20 Days",
            projectArea: "Network Benchmark Testing ",
          },
          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "45 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: "Walk Test (RailWay)",
            year: "2022",
            duration: "75 Days",
            projectArea: "Network Performance Testing ",
          },
        ],
      },

      // Greece
      {
        name: "Greece",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "03 Days",
            projectArea: "Network Pre-Benchmark",
          },
          {
            project: "Drive Test",
            year: "2024",
            duration: "07 Days",
            projectArea: "Network Benchmark",
          },
          {
            project: "Drive Test",
            year: "2024",
            duration: "17 Days",
            projectArea: "Certification Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "07 Days",
            projectArea: "Network Pre-benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "20 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "07 Days",
            projectArea: "Network Pre-benchmark Testing",
          },
          {
            project: "Drive Test",
            year: "2023",
            duration: "18 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "22 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "22 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "11 Days",
            projectArea: "Network Pre-benchmark Test",
          },
        ],
      },
      // Switzerland
      {
        name: "Switzerland",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "12 Days",
            projectArea: "Certification",
          },
          {
            project: "Walk Test",
            year: "2024",
            duration: "03 Days",
            projectArea: " Railway Network Benchmark Test",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "10 Days",
            projectArea: " Sanity Check",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "04 Days",
            projectArea: " Sanity Check",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "10 Days",
            projectArea: " Sanity Check",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "13 Days",
            projectArea: " Sanity Check",
          },

          {
            project: "Drive Test/ Walk Test",
            year: "2023",
            duration: "30 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Secuirty Check",
            year: "2023",
            duration: "10 Days",
            projectArea: " Network Security Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "07 Days",
            projectArea: " Network Performance Check",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "09 Days",
            projectArea: " Network Performance Check",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "16 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "14 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "02 Days",
            projectArea: " Network Performance Check",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "07 Days",
            projectArea: " Network Performance Check",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "60 Days",
            projectArea: " Network Implementation",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "16 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "35 Days",
            projectArea: " Network Implementation",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "35 Days",
            projectArea: " Network Benchmark Testing",
          },
        ],
      },
      // spain
      {
        name: "Spain",
        projects: [
          {
            project: "Drivetest / Walktest",
            year: "2024",
            duration: "18 Days",
            projectArea: "Network Benchmark",
          },
          {
            project: "Drive Test / Walk Test",
            year: "2024",
            duration: "22 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "30 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "25 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "35 Days",
            projectArea: "Network Benchmark Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "32 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "32 Days",
            projectArea: "Network Pre-benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "37 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Security Check",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Security Testing",
          },
        ],
      },
      // Portugal
      {
        name: "Portugal",
        projects: [
          {
            project: "Drive Test and Walk Test",
            year: "2024",
            duration: "17 Days",
            projectArea: "Certification Testing",
          },
          {
            project: "Drive Test",
            year: "2024",
            duration: "08 Days",
            projectArea: "Sanity Check ",
          },

          {
            project: "Security Check",
            year: "2023",
            duration: "05 Days",
            projectArea: "Network Security Testing ",
          },
          {
            project: "Security Check / Drive Test",
            year: "2023",
            duration: "05 Days",
            projectArea: "Network Security Testing ",
          },

          {
            project: "Security Check / Drive Test",
            year: "2023",
            duration: "03 Days",
            projectArea: "Network Security Testing ",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: "Security Check",
            year: "2022",
            duration: "03 Days",
            projectArea: "Network Security Testing ",
          },

          {
            project: "Security Check / Drive Test",
            year: "2022",
            duration: "04 Days",
            projectArea: "Network Security Testing ",
          },
        ],
      },
      // Italy
      {
        name: "Italy",
        projects: [
          {
            project: "Drive Test and Walk Test",
            year: "2024",
            duration: "26 Days",
            projectArea: "Network Benchmark Testing",
          },
          {
            project: "Drive Test",
            year: "2024",
            duration: "20 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "20 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: " Walk Test",
            year: "2023",
            duration: "03 Days",
            projectArea: "Network Performance Test ",
          },

          {
            project: " Drive Test",
            year: "2023",
            duration: "40 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: " Drive Test",
            year: "2023",
            duration: "07 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: " Drive Test / Walk Test",
            year: "2022",
            duration: "27 Days",
            projectArea: "Network Benchmark Testing ",
          },

          {
            project: " Drive Test / Walk Test",
            year: "2022",
            duration: "16 Days",
            projectArea: "Network Pre-benchmark Testing ",
          },
        ],
      },
      // Denmark
      {
        name: "Denmark",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "18 Days",
            projectArea: "Network Benchmark",
          },

          {
            project: " Security Check /Drive Test ",
            year: "2022",
            duration: "05 Days",
            projectArea: "Network Security Testing ",
          },
        ],
      },
      //Icland
      {
        name: "Iceland",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "08 Days",
            projectArea: "Network Benchmark",
          },
        ],
      },
      // France
      {
        name: "France",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "03 Days",
            projectArea: "Roaming Test",
          },

          {
            project: "Device Testing",
            year: "2024",
            duration: "03 Days",
            projectArea: "User Acceptance Testing",
          },
        ],
      },
      // Austria
      {
        name: "Austria",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "03 Days",
            projectArea: "Roaming Test",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "27 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Security Check",
            year: "2023",
            duration: "08 Days",
            projectArea: "Network Security Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "25 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "10 Days",
            projectArea: "Network Performance Testing",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "10 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },

      // Netherland

      {
        name: "Netherland",
        projects: [
          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "12 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: " Walk Test (RailWay)",
            year: "2023",
            duration: "03 Days",
            projectArea: "Network Performance Test (Railway)",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "07 Days",
            projectArea: "Network Pre-benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Walk Test",
            year: "2022",
            duration: "14 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2022",
            duration: "31 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },

      // Romania

      {
        name: "Romania",
        projects: [
          {
            project: "Sanity Check ",
            year: "2023",
            duration: "05 Days",
            projectArea: "Network Performance Testing",
          },

          {
            project: "Drive Test / Walk Test ",
            year: "2022",
            duration: "12 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test / Walk Test ",
            year: "2022",
            duration: "26 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },

      // Luxembourg
      {
        name: "Luxembourg",
        projects: [
          {
            project: "Drive Test ",
            year: "2023",
            duration: "08 Days",
            projectArea: "Frequency Check",
          },
        ],
      },

      // Albania

      {
        name: "Albania",
        projects: [
          {
            project: "Drive Test ",
            year: "2023",
            duration: "09 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test ",
            year: "2022",
            duration: "13 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test ",
            year: "2022",
            duration: "07 Days",
            projectArea: "Network Pre-benchmark Testing",
          },
        ],
      },

      // Czech Republic

      {
        name: "Czech Republic",
        projects: [
          {
            project: "Drive Test / Walk Test ",
            year: "2022",
            duration: "20 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },

      //  Hungary

      {
        name: "Hungary",
        projects: [
          {
            project: "Drive Test / Walk Test ",
            year: "2022",
            duration: "18 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },
    ],
  },

  // projects data section for gulf  region
  {
    label: "Gulf",
    countries: [
      // Unitied Arab Emeritias
      {
        name: "United Erab Emirates",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "41 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "25 Days",
            projectArea: "Network Benchmark Testing",
          },

          {
            project: "Device Testing",
            year: "2023",
            duration: "15 Days",
            projectArea: "User Acceptance Testing",
          },

          {
            project: "Device Testing",
            year: "2023",
            duration: "15 Days",
            projectArea: "SOS Emergency Call Testing",
          },
        ],
      },

      // Kingdom of Saudi Arabia
      {
        name: "Kingdom of Saudi Arabia",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "1 Month 11 Days",
            projectArea: "Benchmark",
          },
        ],
      },
      // Behrain
      {
        name: "Bahrain",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "1 Month 11 Days",
            projectArea: "Benchmark",
          },
        ],
      },
    ],
  },

  // projects data section for Asia  region
  {
    label: "Asia",
    countries: [
      {
        name: "Korea",
        projects: [
          {
            project: "Drive Test",
            year: "2023",
            duration: "16 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Drive Test",
            year: "2022",
            duration: "19 Days",
            projectArea: " Network Benchmark Testing",
          },

          {
            project: "Device Test",
            year: "2022",
            duration: "06 Days",
            projectArea: " User Acceptance Testing",
          },
        ],
      },
    ],
  },

  // projects data section for unitied kingdom

  {
    label: "Unitied Kingdom and Ireland ",
    countries: [
      {
        name: "Unitied Kingdom",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "125 Days",
            projectArea: "DCC Test",
          },
          {
            project: "Drive Test / Walk Test",
            year: "2024",
            duration: "07 Days",
            projectArea: "Certification Testing",
          },

          {
            project: "Drive Test",
            year: "2023",
            duration: "14 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: "Drive Test / Walk Test",
            year: "2023",
            duration: "18 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: "Drive Test ",
            year: "2023",
            duration: "18 Days",
            projectArea: "XCAL Check",
          },

          {
            project: " Walk Test",
            year: "2022",
            duration: "21 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: " Walk Test",
            year: "2022",
            duration: "27 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: " Drive Test",
            year: "2022",
            duration: "27 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: " Walk Test",
            year: "2022",
            duration: "27 Days",
            projectArea: "Network Bechmark Testing",
          },

          {
            project: " Security Check / Drive Test",
            year: "2022",
            duration: "05 Days",
            projectArea: "Network Security Testing",
          },

          {
            project: "Drive test / Walk Test",
            year: "2022",
            duration: "30 Days",
            projectArea: "Network Bechmark and Performance Testing",
          },
        ],
      },

      // Ireland projects Data start
      {
        name: "Ireland",
        projects: [
          {
            project: "Drive Test",
            year: "2024",
            duration: "04 Days",
            projectArea: "Pre-Benchmark Testing",
          },
          {
            project: "Drive Test and Walk Test",
            year: "2024",
            duration: "17 Days",
            projectArea: "Network Benchmark Testing",
          },
        ],
      },
    ],
  },
];
